// extracted by mini-css-extract-plugin
module.exports = {"ipInputContainer":"ipInput_ipInputContainer_1C8HR","ipSegment":"ipInput_ipSegment_2CCzg","ipSegmentInput":"ipInput_ipSegmentInput_Mf4Ed","ipI":"ipInput_ipI_1IwoG"};